import { Colors, TextStylesMobile, TextStylesDesktop, Media } from 'enums';
import styled from 'styled-components';

export const RadioLabel = styled.label<{ disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: start;
  user-select: none;
  max-width: max-content;

  ${({ disabled }) =>
    !disabled && {
      cursor: 'pointer',
    }}
`;

export const TextBlock = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const RadioInput = styled.input`
  appearance: none;
  position: relative;
  top: 4px;

  display: block;
  box-sizing: border-box;
  height: 20px;
  width: 20px;
  margin-right: 8px;

  border: 1px solid ${Colors.gray3};
  border-radius: 50%;

  transition: 0.2s all linear;
  transform: translateY(-3px);

  &:checked {
    border: 6px solid ${Colors.yellow1};
  }

  ${({ disabled }) =>
    disabled
      ? {
          opacity: 0.5,
        }
      : {
          cursor: 'pointer',
        }}

  @media ${Media.notebook} {
    height: 24px;
    width: 24px;
    margin-right: 18px;
  }
`;

export const SubLabelWrapper = styled.span`
  display: block;
  margin-left: 42px;
`;

export const StyledSubLabel = styled.p`
  ${TextStylesMobile.small1}
  color: ${Colors.gray2};

  @media ${Media.notebook} {
    ${TextStylesDesktop.small1}
  }
`;
